import http, { type Http } from '@/lib/http';
import { ExistingFundedOperation, FilterOptions } from './get_orders';

export type PaymentDetails = {
  paidInstallments: number;
  currentTotalPaidAmountInCents: number;
  currentPrincipalAmountInCents: number;
  currentInterestAmountInCents: number;
};

export type Loan = {
  id: string;
  completedAt: string;
  customerId: string;
  customerName: string;
  customerEmail: string;
  checkoutName: string;
  productName: string;
  amountInCents: number;
  term: number;
  currency: string;
  country: string;
  paidAmountInCents: string;
  status: string;
  isRefundable: boolean;
  isCancellable: boolean;
  existingFundedOperation: ExistingFundedOperation | null;
  paymentDetails: PaymentDetails | null;
};

type GetLoansResponse = {
  loans: Loan[];
  totalCount: number;
  statusFilters: { label: string; value: string }[];
};

type Params = {
  projectId: string;
  filter: FilterOptions;
};

function ctor(http: Http) {
  return async ({ projectId, filter }: Params): Promise<GetLoansResponse> => {
    const { data } = await http.get(`/projects/${projectId}/loans`, {
      params: filter,
    });

    return {
      loans: data.items,
      totalCount: data.total,
      statusFilters: data.statuses,
    };
  };
}

export const getLoans = ctor(http);
